module.exports = __webpack_public_path__ + "img/banner-international-shipping.6da5ce1f.png";